import { connect } from 'react-redux';
import { CART } from 'swag-common/constants/item-sources';
import { isPreBuiltLimitedCartOpenedByCustomerSelector } from 'swag-client-common/redux/cart/cart.selectors';
import { isResellerInOrderCreationModeSelector } from 'swag-client-common/redux/user/user.selectors';
import { checkIsSuperSpeedAddonWarnSelector, checkIsWholeBoxSuperSpeedSelector, productionTimeListForItemSelector } from '../../../../../../redux/cart/cart.selectors';
import { placeSampleInCart } from '../../../../../../redux/product/product.actions';
import { BoxOrderItemList } from './box-order-item-list';
const mapStateToProps = (state, props) => {
  return {
    productionTimeList: productionTimeListForItemSelector(state, props),
    isSampleButtonShown: false,
    isWholeBoxSuperSpeed: checkIsWholeBoxSuperSpeedSelector(state, props),
    isSuperSpeedAddonWarn: checkIsSuperSpeedAddonWarnSelector(state, props),
    isPreBuiltLimitedCart: isPreBuiltLimitedCartOpenedByCustomerSelector(state),
    isResellerInOrderCreationMode: isResellerInOrderCreationModeSelector(state)
  };
};
const mapDispatchToProps = dispatch => ({
  onBoxSampleClick: boxToMoveId => {
    dispatch(placeSampleInCart({
      // @todo. auto generated. fix this error
      // @ts-ignore
      isPrintedSample: false,
      // @todo. auto generated. fix this error
      // @ts-ignore
      isSwagSampleBox: true,
      isScrollEnabled: true,
      // @todo. auto generated. fix this error
      // @ts-ignore
      source: CART,
      boxToMoveId
    }));
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(BoxOrderItemList);